import resize from './resize.js'
import scroll from './scroll.js'

export const ResizeMonitor = resize
export const ScrollMonitor = scroll